import { VERSIONS_GRAPH_DATA, CAMPAIGN_DATA_FOR_ASSET } from "../../constants/actionTypes";
import {
  IGraphData,
  IAssetGraphData,
  IAssetGraphDataLoading,
  IVersionGraphDataLoading,
  IVersionGraphData,
  ICampaignDataForAsset,
  ICampaignDataForAssetLoading,
} from "./interfaces";

const initialVersionGraphDataState: IVersionGraphDataLoading = {
  loading: false,
  data: {},
};
const initialCampaignDataForAssetState: ICampaignDataForAssetLoading = {
  loading: false,
  data: {},
};

interface IVersionGraphDataAction {
  type: string;
  payload: IVersionGraphData;
}
export const versionReducer = (
  state: IVersionGraphDataLoading = initialVersionGraphDataState,
  action: IVersionGraphDataAction
) => {
  const new_state: IAssetGraphDataLoading = { ...state };
  switch (action.type) {
    case VERSIONS_GRAPH_DATA.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.data = { ...state.data, ...action.payload };
      return new_state;

    case VERSIONS_GRAPH_DATA.LOAD:
      new_state.loading = true;
      new_state.data = {};
      return new_state;

    case VERSIONS_GRAPH_DATA.LOAD_FAIL:
      new_state.loading = false;
      new_state.data = {};
      return new_state;

    default:
      return state;
  }
};

interface ICampaignDataForAssetAction {
  type: string;
  payload: ICampaignDataForAsset;
}

export const campaignDataForAssetReducer = (
  state: ICampaignDataForAssetLoading = initialCampaignDataForAssetState,
  action: ICampaignDataForAssetAction
) => {
  const new_state: ICampaignDataForAssetLoading = { ...state };
  switch (action.type) {
    case CAMPAIGN_DATA_FOR_ASSET.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.data = { ...state.data, ...action.payload };
      return new_state;

    case CAMPAIGN_DATA_FOR_ASSET.LOAD:
      new_state.loading = true;
      new_state.data = {};
      return new_state;

    case CAMPAIGN_DATA_FOR_ASSET.LOAD_FAIL:
      new_state.loading = false;
      new_state.data = {};
      return new_state;

    case CAMPAIGN_DATA_FOR_ASSET.CLEAR:
      new_state.loading = false;
      new_state.data = {};
      return new_state;

    default:
      return state;
  }
};
